import { BaseService } from './baseService';
import { DiseaseDto, diseaseFormData } from '../types/disease';

class DiseaseService extends BaseService<DiseaseDto, typeof diseaseFormData> {
    constructor() {
        super('/Disease');
    }
}

export const diseaseService = new DiseaseService();